import { render, staticRenderFns } from "./ahDocUploader.vue?vue&type=template&id=64bf667c&scoped=true&"
import script from "./ahDocUploader.vue?vue&type=script&lang=js&"
export * from "./ahDocUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bf667c",
  null
  
)

export default component.exports